import React, { useEffect, useState } from "react";
import Layout from "../../../layout";

import { Link } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

const NovidadeListar = () => {
  const [state, setState] = useState([]);

  const carregarDados = async () => {
    try {
      showLoading(".ibox-content");

      const requisicao = await api.get("/novidade");

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      setState(data.data);
      window.$("#table-novidade").footable();
      showLoading(".ibox-content");
    } catch (error) {
      console.log(error);
      showLoading(".ibox-content");
      danger("Erro ao carregar os dados das novidades");
    }
  };

  useEffect(() => carregarDados(), []);

  const excluirNovidade = (novidade) => {
    window.swal(
      {
        title: "Você tem certeza?",
        text: `Deseja realmente excluir a novidade ${novidade.nome}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        closeOnConfirm: true,
      },
      async () => {
        try {
          const { data } = await api.delete(`/novidade/${novidade.id}`);

          if (!data.status) {
            danger(data.mensagem);
            return;
          }

          success(data.mensagem);

          carregarDados();
        } catch (error) {
          console.log(error);
          danger("Erro ao deletar a novidade");
        }
      }
    );
  };

  return (
    <>
      <Layout
        titulo="Ibraflex - Novidades"
        header="Listagem de Novidades"
        action={{ titulo: "Cadastrar", link: "/novidade/cadastrar" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox">
              <div className="ibox-title">
                <h5>Listagem das novidades cadastradas</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                {state.length <= 0 ? (
                  <>
                    <input
                      type="text"
                      className="form-control form-control-sm m-b-xs"
                      id="filter"
                      placeholder="Pesquisar na tabela"
                    ></input>
                    <table
                      id="table-novidade"
                      className="footable table table-stripped toggle-arrow-tiny"
                      data-filter="#filter"
                    >
                      <thead>
                        <tr>
                          <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                          <th>Imagem</th>
                          <th>Título</th>
                          <th>Data</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                    </table>
                  </>
                ) : (
                  <>
                    <input
                      type="text"
                      className="form-control form-control-sm m-b-xs"
                      id="filter"
                      placeholder="Pesquisar na tabela"
                    ></input>
                    <table
                      id="table-novidade"
                      className="footable table table-stripped toggle-arrow-tiny"
                      data-filter="#filter"
                    >
                      <thead>
                        <tr>
                          <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                          <th>Imagem</th>
                          <th>Título</th>
                          <th>Data</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {state.map((novidade) => (
                          <tr key={novidade.id}>
                            <td>{novidade.id}</td>
                            <td>
                              <img
                                src={novidade.url}
                                alt=""
                                className="img-md rounded"
                              />
                            </td>
                            <td>{novidade.titulo}</td>
                            <td>{novidade.data}</td>
                            <td>
                              <div className="btn-group">
                                <button
                                  data-toggle="dropdown"
                                  className="btn btn-success btn-xs dropdown-toggle"
                                >
                                  Opções
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <Link
                                      to={{
                                        pathname: "/novidade/editar",
                                        state: { id: novidade.id },
                                      }}
                                      className="dropdown-item"
                                      id="editar"
                                    >
                                      Editar
                                    </Link>
                                  </li>
                                  <li>
                                    <a
                                      href="#!"
                                      className="dropdown-item"
                                      id="alerta-excluir"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        excluirNovidade(novidade);
                                      }}
                                    >
                                      Excluir
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="6">
                            <ul className="pagination float-right"></ul>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default NovidadeListar;
